module.exports = __webpack_public_path__ + "static/media/Laptop.72adc717.jpg";